import { htmlToOoxml } from "./HTML";
import { maxNumId } from "./Helper";
import { cloneOOXMLData } from "./OOXML";

function processRichNode(ctx, node) {
    if (node._fTextNode) {
        let mainMatch = /~~~(INLINE_)?RICHTEXT\s(.*)~~~/gi.exec(node._text);
        if (mainMatch) {
            if (mainMatch[1] === "INLINE_") ctx.removeParagraph = true;
            
            const result = htmlToOoxml(ctx, mainMatch[2], node._parent);
            if (mainMatch[1] === "INLINE_") ctx.removeParagraph = false;
            return result;
        } else {
            return node;
        }
    } else if (node._tag === "w:r" || node._tag === "w:t") {
        const finder = node._tag === "w:r"? a => a._tag === "w:t" : a => a._fTextNode;
        const tNode = node._children.find(finder);
        if (tNode) {
            const result = processRichNode(ctx, tNode);
            if (Array.isArray(result)) return result;
        }
        return node;
            
    } else {
        const children = [];
        for (let c = 0; c < node._children.length; c++) {
            const child = node._children[c];
            if (child._tag === "w:p") {
                ctx.afterParagraph = [];
                const pPrChild = child._children.find(c => c._tag === "w:pPr");
                if (pPrChild) {
                    ctx.pPrChildren = pPrChild._children;
                }
            }
            
            const result = processRichNode(ctx, child);
            
            if (Array.isArray(result)) {
                if(Array.isArray(ctx.afterParagraph)) {
                    const [first, ...rest] = result;
                    if (!first) continue;
                    if (first && first._tag === "w:p") {
                        first._children.forEach(firstChild => {
                            if(firstChild._tag === 'w:r') {
                                children.push({...firstChild, _parent: node});
                            }
                        });
                    } else if (first._tag === "w:tbl") {
                        ctx.afterParagraph.push(first);
                    } else children.push({...first, _parent: node});

                    rest.forEach(restItem => {
                        if (restItem._tag === "w:p") {
                            if (ctx.pPrChildren) {
                                const existingPPr = restItem._children.find(c => c._tag === "w:pPr");
                                if (existingPPr) {
                                    existingPPr._children = [...existingPPr._children, 
                                        ...ctx.pPrChildren.filter(pprChild => {
                                            return !existingPPr._children.find(c => c._tag === pprChild._tag);
                                        }).map(pprChild => cloneOOXMLData(pprChild, existingPPr))
                                    ];
                                } else {
                                    const ppr = { _tag: "w:pPr", _children: [], _parent: restItem};
                                    ctx.pPrChildren.forEach(pprChild => {
                                        ppr._children.push(cloneOOXMLData(pprChild, ppr));
                                    });
                                    restItem._children.unshift(ppr);
                                }
                            }
                            ctx.afterParagraph.push(restItem);
                        } else {
                            children.push({...restItem, _parent: node});
                        }
                    });
                } else {
                    result.map(r => children.push({...r, _parent: node}));
                }
            } else if (result) {
                children.push({ ...result, _parent: node});
            }

            if (child._tag === "w:p") {
                ctx.afterParagraph.forEach(afterParagraph => 
                    children.push({...afterParagraph, _parent: node})
                );
                ctx.afterParagraph = false;
            }
        }
        return {...node, _children: children.map(a => ({...a, _parent: node}))};
    }
}

export function processMainXML(ctx, xml, reports) {
    let body = xml._children[0];
    ctx.initialMaxNumId = maxNumId(body);
    ctx.maxNumId = ctx.initialMaxNumId; 
    ctx.links = [];
    
    const result = processRichNode(ctx, xml);

    ctx.links.forEach((url, idx) => {
        reports.links[`rtLinkId${idx}`] = {url};
    });
    return result;
}